import { render, staticRenderFns } from "./monetize-section.vue?vue&type=template&id=5711e2e6&scoped=true&"
import script from "./monetize-section.vue?vue&type=script&lang=js&"
export * from "./monetize-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711e2e6",
  null
  
)

export default component.exports